<template>
  <div>
    <div class="table-header row">
      <div>
        时间
      </div>
      <div>
        操作账号
      </div>
      <div>
        操作IP/省份城市
      </div>
      <div>操作平台</div>
      <div>事件类型</div>
      <div>描述</div>
    </div>
    <div class="table-body">
      <div class="row" v-for="(item, index) in tableList" :key="index">
        <!-- 时间 -->
        <div class="operationAccount">
          <p v-text="item.date"></p>
          <p v-text="item.time"></p>
        </div>
        <!-- 操作账号 -->
        <div class="operationAccount">
          <p v-text="item.passportName"></p>
          <p v-text="item.passportType"></p>
        </div>
        <!-- 操作IP、省份城市 -->
        <div class="operationAccount">
          <p v-text="item.ip"></p>
          <p v-if="item.areaName == '' || item.areaName == null">
            - -
          </p>
          <p v-if="item.areaName != ''" v-text="item.areaName"></p>
          <!-- <p>{{item.ip | cityName}}</p> -->
        </div>
        <!-- 操作平台 -->
        <div>
          <span v-text="item.sourceValue"></span>
        </div>
        <!-- 事件类型 -->
        <div>
          <span v-text="item.operationValue"></span>
        </div>
        <!-- 描述 -->
        <div>
          <span :title="item.operationRemark" v-text="item.operationRemark"></span>
        </div>
      </div>
      <no-data style="height:auto;padding-top:20px;padding-bottom:20px;" v-show="tableList.length == 0 || loading"
        :nodata="tableList.length == 0 && !loading" :loading="loading"></no-data>
    </div>
  </div>
</template>

<script>
import NoData from '_c/noData/noData';
import { getCity } from '@/requests/bar'
export default {
  name: 'operationLog-table',
  components: {
    NoData
  },
  props: {
    tableList: {
      type: Array,
      default () {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    // async cityName(ip) {
    //   console.log(222)
    //   let res = await getCity(ip)
    //   console.log(res.country)
    //   return res.country + '--' + res.city
    // }
  },
  data () {
    return {
      operationLogList: []
    };
  },
  mounted () {
    // this.getCity()
  },
  watch: {
    tableList () {
      this.tableList.forEach(item => {
        item.date = item.createTime.split('T')[0];
        item.time = item.createTime.split('T')[1];
        switch (item.passportType) {
          case 0:
            item.passportType = '主账号';
            break;
          case 2:
            item.passportType = '员工';
            break;
          case 3:
            item.passportType = '业主';
            break;
          default:
            item.passportType = '--';
            break;
        }
        return item;
      });
    }
  },
  methods: {

    // async getCity() {
    //   console.log(222)
    //   let res = await getCity('115.192.103.122')
    //   console.log(res)
    //   console.log(23)
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
  width: 100%;
  @include clearfix();

  &:after {
    content: "";
    top: 0;
    left: 0;
    display: block;
    font-size: 0;
    height: 0;
    width: 0;
    clear: both;
    visibility: hidden;
  }

  >div {
    float: left;
    text-align: left;
    text-overflow: ellipsis;
    height: 50px;

    span {
      @include ellipsis();
      display: inline-block;
      max-width: 100%;
    }

    p {
      @include ellipsis();
      max-width: 100%;
    }
  }

  >div:nth-child(1) {
    width: 9%;
    padding-left: 10px;
  }

  >div:nth-child(2) {
    width: 9%;
  }

  >div:nth-child(3) {
    width: 10%;
  }

  >div:nth-child(4) {
    width: 10%;
  }

  >div:nth-child(5) {
    width: 10%;
  }

  >div:nth-child(6) {
    width: 45%;
  }
}

.table-header {
  >div {
    height: 30px;
    line-height: 30px;
  }
}

.operationAccount {
  p {
    line-height: normal;
    line-height: 14px;
  }

  p:nth-child(1) {
    padding-top: 10px;
  }

  p:nth-child(2) {
    color: $gray-word;
  }
}
</style>
